module.exports = __webpack_public_path__ + "img/authForteOk.b588a95e.png";